/**
 * Runtime constants — labels, badge class-name maps, and helper functions.
 * All badge class names reference component classes defined in index.css
 * and documented in src/lib/tokens.ts.
 */
import { CallDisposition } from '../types'

// ── Wallet thresholds ─────────────────────────────────────────────────────────

/** Wallet balance below which we consider it "low" — used in Admin dashboard and My Plan. */
export const LOW_WALLET_THRESHOLD = 3_000

// ── Call disposition labels ────────────────────────────────────────────────

export const DISPOSITION_LABELS: Record<string, string> = {
  [CallDisposition.CALLBACK_REQUESTED]:       'Callback Requested',
  [CallDisposition.NOT_INTERESTED]:           'Not Interested',
  [CallDisposition.ASKING_FOR_DISCOUNT]:      'Asking for Discount',
  [CallDisposition.CUSTOMER_BOOKED_ELSEWHERE]:'Booked Elsewhere',
  [CallDisposition.SOLD_VEHICLE]:             'Sold Vehicle',
  [CallDisposition.DUE_DATE_LAPSED]:          'Due Date Lapsed',
  [CallDisposition.IN_PROCESS]:               'In Process',
  [CallDisposition.NO_ANSWER]:                'No Answer',
  [CallDisposition.WRONG_NUMBER]:             'Wrong Number',
}

// ── Lead status → badge class ──────────────────────────────────────────────

export const LEAD_STATUS_COLORS: Record<string, string> = {
  NEW:                    'badge-info',
  WHATSAPP_QUALIFYING:    'badge-info',
  QUALIFIED:              'badge-info',
  CALLBACK_REQUESTED:     'badge-warning',
  QUOTATION_SENT:         'badge-warning',
  IN_NEGOTIATION:         'badge-warning',
  POLICY_ISSUED:          'badge-success',
  LOST:                   'badge-danger',
  LOST_RENEWED_ELSEWHERE: 'badge-danger',
  NOT_RESPONSIVE:         'badge-neutral',
  DUPLICATE:              'badge-neutral',
  STALE:                  'badge-neutral',
}

export const LEAD_STATUS_LABELS: Record<string, string> = {
  NEW:                    'New',
  WHATSAPP_QUALIFYING:    'WA Qualifying',
  QUALIFIED:              'Qualified',
  CALLBACK_REQUESTED:     'Callback',
  QUOTATION_SENT:         'Quote Sent',
  IN_NEGOTIATION:         'Negotiating',
  POLICY_ISSUED:          'Policy Issued',
  LOST:                   'Lost',
  LOST_RENEWED_ELSEWHERE: 'Lost – Elsewhere',
  NOT_RESPONSIVE:         'Not Responsive',
  DUPLICATE:              'Duplicate',
  STALE:                  'Stale',
}

// ── Priority score → badge style ──────────────────────────────────────────

export function priorityBadgeClass(score: number): string {
  if (score > 50) return 'badge-danger'
  if (score > 20) return 'badge-warning'
  return 'badge-neutral'
}

// ── Fraud severity → badge class ──────────────────────────────────────────

export const SEVERITY_COLORS: Record<string, string> = {
  LOW:      'badge-neutral',
  MEDIUM:   'badge-warning',
  HIGH:     'badge-orange',
  CRITICAL: 'badge-danger',
}

// ── User role → badge class ────────────────────────────────────────────────

export const ROLE_COLORS: Record<string, string> = {
  BACKEND_ADMIN:    'badge-purple',
  DEALER_PRINCIPAL: 'badge-info',
  INSURANCE_HEAD:   'badge-success',
  TEAM_LEADER:      'badge-warning',
  TELECALLER:       'badge-neutral',
}

export const ROLE_LABELS: Record<string, string> = {
  BACKEND_ADMIN:    'Backend Admin',
  DEALER_PRINCIPAL: 'Dealer Principal',
  INSURANCE_HEAD:   'Insurance Head',
  TEAM_LEADER:      'Team Leader',
  TELECALLER:       'Telecaller',
}
